module.exports = __webpack_public_path__ + "img/eyecon-invert.5039be0d.svg";